import { Component, Input } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  @Input() control!: AbstractControl;
  @Input() customErrorMessage?: string;

  get errorMessage(): string | null {
    if (!this.control || !this.control.errors || !(this.control.dirty || this.control.touched)) {
      return null;
    }

    if (this.customErrorMessage) {
      return this.customErrorMessage;
    }

    const errors: ValidationErrors = this.control.errors;

    if (errors['required']) return 'This field is required';
    if (errors['email']) return 'Invalid email address';
    if (errors['invalidValue']) return 'Please select at least one value from the dropdown';
    if (errors['minValue']) return 'Please add value more than 0';
    if (errors['minlength']) return `Minimum ${errors['minlength'].requiredLength} characters required`;
    if (errors['maxlength']) return `Maximum ${errors['maxlength'].requiredLength} characters allowed`;
    if (errors['pattern']) {
      if (this.control?.parent?.get('gstinNumber') === this.control) {
        return 'Invalid GSTIN format';
      } else if (this.control?.parent?.get('panNumber') === this.control) {
        return 'Invalid PAN format';
      }
      return 'Invalid format';
    }
    if (errors['sameAsCurrent']) return 'New password must be different from current password';
    if (errors['passwordMismatch']) return 'Passwords do not match';

    return 'Invalid input';
  }

}
